import get from 'lodash/get'
import {createDocument} from 'utils/db.utils'

export default function setTypingIndicator({roomId, user, isTyping = true}) {
  const uid = get(user, 'uid')
  if (!roomId && !uid) return null

  return createDocument(`chats/${roomId}/typings`, {uid, user, isTyping})
}
